module.exports = __webpack_public_path__ + "img/2BB.1.72527f40.jpg";